import CityManagementPage from "./shared/CityManagementPage";
import { cityConfigs } from "./shared/cityConfig";

export default function Birmingham() {
  return <CityManagementPage config={cityConfigs.birmingham} />;
}